module.exports = __webpack_public_path__ + "img/empty-placeholder.66ffc630.png";